import React, { useEffect, useState } from 'react';

import './BackgroundSlider.css';


const BackgroundSlider = ({ images, interval }) => {
    const [currentImage, setCurrentImage] = useState(images[0]);
    const [nextImage, setNextImage] = useState(images[0]);
    const [isFading, setIsFading] = useState(false);

    useEffect(() => {
        // Reset to the first image when the images array changes
        setCurrentImage(images[0]);
        setNextImage(images[0]);
    }, [images]);

    useEffect(() => {
        const changeImage = () => {
            setIsFading(true);
            setNextImage((prevImage) => {
                const currentIndex = images.indexOf(prevImage);
                const nextIndex = (currentIndex + 1) % images.length;
                return images[nextIndex];
            });
        };

        const intervalId = setInterval(changeImage, interval);

        return () => clearInterval(intervalId);
    }, [images, interval]);

    useEffect(() => {
        if (isFading) {
            const fadeTimeout = setTimeout(() => {
                setCurrentImage(nextImage);
                setIsFading(false);
            }, 1500); // Match this to the CSS transition duration
            return () => clearTimeout(fadeTimeout);
        }
    }, [isFading, nextImage]);

    return (
        <div className="background-slider-container">
            <div
                className="background-slider current"
                style={{
                    backgroundImage: `url(${currentImage})`,
                }}
            />
            <div
                className={`background-slider next ${isFading ? 'visible' : ''}`}
                style={{
                    backgroundImage: `url(${nextImage})`,
                }}
            />
        </div>
    );
};

export default BackgroundSlider;
